import Axios from 'axios';
import { cents } from './filters/number'

const recharge = [21, 22, 31, 32, 35, 36, 37, 38, 4, 5, 51, 52, 45, 55, 62, 64];
const rechargeAut = [22, 32, 36, 38, 4, 5, 45, 55, 62, 64];
export default {
  computed:{
    window(){
      return window;
    }
  },
  methods:{
    async getRechargeRates(planId) {
      return await Axios.get(`/v2/getRechargeRates/${this.planId}`);
    },
    planHasRecharge(planId){
      return recharge.indexOf(parseInt(planId)) >= 0;
    },
    planHasAutRecharge(planId){
      return rechargeAut.indexOf(parseInt(planId)) >= 0;
    },
    getKindPlan(planId){
      switch (parseInt(planId)) {

        case 28:
          return 'POS_PAGO';

        case 21:
        case 31:
        case 35:
        case 37:
        case 51:
        case 70:
        case 71:
          return 'PRE_MAN';
        case 22:
        case 32:
        case 36:
        case 38:
        case 52:
        case 4:
        case 5:
        case 62:
        case 64:
          return 'PRE_AUTO';

        case 33:
          return 'MOVE_PAGUE';

        case 2:
        case 3:
          return 'RNTRC';

        case 6:
          return 'EMBARCADOR-PRE';
        case 8:
          return 'EMBARCADOR-POS';
        case 23:
        case 7:
          return 'VALE';
        case 45:
        case 46:
          return 'AGREGADO';
      }
    },

    getPercentRechargeAut(planId){
      if(planId == 31 || planId == 32 || planId == 64)
        return 30;

      return 40;
    },

    getMultipleRecharge(planId){
      if(planId == 31 || planId == 32 || planId == 64)
        return 50000;
      else if(planId == 51 || planId == 52)
        return 2500;
      // else if(planId == 64)
      //   return 25000;
      else
        return 5000;
    },

    getMinOpenValue(planId){

      if(planId == 31 || planId == 32|| planId == 5 || planId == 64)
        return 200000;
      else if(planId == 51 || planId == 52)
        return 2500;
      else
        return 5000;
    },

    //  * {value: 200000, tax: 10000, caption: cents(200000)}
    // GATORADE
    calculate(planId, value) {
      let promise = Sales.calculateRechargeRate({
        value: value,
        planId: planId,
        contractId: 0,
      }).then((r) => {


      });

      this.$store.dispatch("loading", promise);
    },
    getFixesRecharges(planId, minValue, icFull){

      let arrayRetorno = [];

      this.getRechargeRates(planId).then ((e) => {
        e.data.response.forEach(element => {
          let elm = {value: element[3], tax: element[4], caption: cents(element[3])};
          arrayRetorno.push(elm);
        });
        if (!icFull) {
          arrayRetorno.push({value:-1, tax: 999, caption: "Valor maior que " + cents(minValue)});
        }
      });

      return arrayRetorno;
    },

    formatTaxId(tax){
      if(!tax)
        return undefined;

      tax = tax.replace();
      if(tax.length == 14)
        return tax.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
      else
        return tax.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');

    }

  }
}



// WEBPACK FOOTER //
// ./src/vue-mixin.js